import axios from 'axios'

import { Routes } from '~/api/api-routes'

import * as types from '../mutation-types'
import auth from '~/store/modules/auth'

let priceListRequest = null

export default {
  namespaced: true,
  state: {
    priceList: [],
    planIdsMap: [],
    trialDaysLeft: null,
  },
  getters: {
    priceList: (state) => state.priceList || [],
    planIdsMap: (state) => state.planIdsMap || [],
    trialDaysLeft: (state) => state.trialDaysLeft,
  },
  mutations: {
    [types.SET_PRICE_LIST](state, { priceList, planIdsMap, trialDaysLeft }) {
      state.priceList = priceList
      state.planIdsMap = planIdsMap
      if (trialDaysLeft !== undefined) state.trialDaysLeft = trialDaysLeft
    },
  },
  actions: {
    setPriceList({ commit }, { priceList, planIdsMap, trialDaysLeft }) {
      commit(types.SET_PRICE_LIST, { priceList, planIdsMap, trialDaysLeft })
    },
    async loadPriceList({ state, commit }) {
      if (Object.keys(state.priceList || {}).length && Object.keys(state.planIdsMap || {}).length) return

      if (priceListRequest) return priceListRequest

      priceListRequest = (async() => {
        const response = await axios.get(Routes.userPlan.getPlanPriceList)
        if (!response.data) {
          throw response
        }

        const hasTrialEndDate = auth?.state?.user?.trial_ends_at

        state.trialDaysLeft = hasTrialEndDate ? null : response.data.trial_days_left
        commit(types.SET_PRICE_LIST, {
          priceList: response.data.price_list,
          planIdsMap: response.data.plan_ids_map,
        })
      })().finally(() => {
        priceListRequest = null
      })

      return priceListRequest
    },
  },
}
